import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5edb125d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "title header-title mt-3" }, "メッセージ設定")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block mt-3",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("テキストメッセージ作成 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_4 = { class: "message-chat-input-container ml-2" }
const _hoisted_5 = { class: "flex justify-content-between align-items-center flex-wrap my-2 relative message-chat-input border-round-lg border-noround-bottom" }
const _hoisted_6 = { class: "flex justify-content-start" }
const _hoisted_7 = { class: "d-flex justify-content-center w-100" }
const _hoisted_8 = { class: "mb-2 p-dialog-title" }
const _hoisted_9 = { class: "message-chat-action" }
const _hoisted_10 = { class: "d-flex justify-content-end" }
const _hoisted_11 = {
  key: 1,
  class: "input-group flex flex-column gap-2 mt-5"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("URLリンク設定"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_13 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_14 = { class: "field col px-0 ml-2" }
const _hoisted_15 = {
  key: 2,
  class: "input-group flex flex-column gap-2 mt-5"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("画像設定"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_17 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_18 = {
  key: 3,
  class: "row d-flex justify-content-space-between"
}
const _hoisted_19 = { class: "col px-0 ml-2" }
const _hoisted_20 = { class: "row xl:flex lg:block justify-content-between" }
const _hoisted_21 = { class: "first-content pl-0" }
const _hoisted_22 = { class: "image-preview-container" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "px-0 second-content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "d-block mt-5",
  for: "menu-title"
}, "アクションタイプを選択", -1))
const _hoisted_26 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_27 = {
  key: 1,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "d-flex justify-content-end" }
const _hoisted_30 = { key: 3 }
const _hoisted_31 = { key: 4 }
const _hoisted_32 = {
  key: 0,
  class: "grid mt-5 mb-5 justify-content-center"
}
const _hoisted_33 = {
  key: 1,
  class: "grid mt-5 justify-content-center"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_35 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 p-dialog-title" }, "下書き保存しました")
], -1))
const _hoisted_37 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_39 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-dialog-header align-items-center w-100 text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "custom-dialog-title header-title" }, "画像を選択")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xl text-orange text-center" }, "↑ 画像をアクセス端末より選ぶ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upload-image-text ml-4" }, "あらかじめ作成した画像を選択して挿入する。", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "upload-image-text ml-4" }, "※ファイルサイズ：10MB以下", -1))
const _hoisted_44 = [
  _hoisted_41,
  _hoisted_42,
  _hoisted_43
]

import { ref, onBeforeMount, reactive, onBeforeUnmount, onMounted } from "vue";
import { get, set } from "@vueuse/core";
import { onBeforeRouteLeave, useRouter } from "vue-router";

// サードパーティライブラリのインポート
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import EmojiPicker from "vue3-emoji-picker";
import { useCookies } from "@vueuse/integrations/useCookies";

// 定数・型定義のインポート
import { GROUP_NAMES_EMOJI, PLACEHOLDER_EMOJI } from "@/clinic/typings/constants/clinic";
import { ILineAccount } from "@/clinic/typings";

// サービス・ユーティリティのインポート
import { useStore } from "vuex";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import axios from "axios";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import rules from "./components/rule";

// 子コンポーネントのインポート
import LiveMessageTemplate from "./LineMessageTemplate.vue";

/**
 * クッキー取得関数
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageSetting',
  props: {
    isEdit: { type: Boolean },
    finalSetting: { type: Boolean },
    distributionGroupId: null,
    deliverySetting: null,
    messageSetting: null
  },
  emits: ["resourcesFn", "saveMessageSetting"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  /** 編集モードかどうか */
  isEdit: boolean;
  /** 最終設定モードかどうか */
  finalSetting: boolean;
  /** 配信グループID */
  distributionGroupId: string | number;
  /** 配信設定情報 */
  deliverySetting: {
    delivery_type: number;
    message_type: number;
    send_at: Date;
  };
  /** メッセージ設定情報 */
  messageSetting: any;
};

/**
 * メッセージ設定コンポーネント
 *
 * このコンポーネントは配信グループのメッセージ設定を管理し、
 * 以下の機能を提供します：
 * - テキストメッセージ作成
 * - URLリンク設定
 * - 画像設定
 * - 絵文字選択
 * - メッセージテンプレート選択
 * - 下書き保存機能
 * - ページ離脱時の警告
 *
 * @component MessageSetting
 * @description 配信グループのメッセージ設定を管理するコンポーネント
 */

// Vue関連のインポート
const { get: getCookie } = useCookies();

/**
 * トースト通知
 * @type {UseToast}
 */
const toast = useToast();

/**
 * ルーター
 * @type {Router}
 */
const router = useRouter();

/**
 * コンポーネントのプロパティ定義
 * @type {Object}
 */


/**
 * Vuexストア
 * @type {Store}
 */
const store = useStore();

/**
 * 画像アップロードポップアップ表示フラグ
 * @type {Ref<boolean>}
 */
const upLoadImagePopUp = ref(false);

/**
 * 下書き保存完了ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const saveDraftVisible = ref(false);

/**
 * 戻る警告ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const warningReturnVisible = ref(false);

/**
 * 既に下書き保存済みかどうか
 * @type {Ref<boolean>}
 */
const isAlreadySaveDraft = ref(false);

/**
 * 現在のメッセージ設定
 * @type {Ref<any>}
 */
const currentMessageSetting = ref({});

/**
 * メッセージ設定エラー
 * @type {Ref<Record<string, any>>}
 */
const messageSettingErrors = ref<Record<string, any>>({});

/**
 * 画像アクションのポストバック
 * @type {Ref<string>}
 */
const imageActionPostBack = ref("");

/**
 * 画像アクションのリンク
 * @type {Ref<string>}
 */
const imageActionLink = ref("");

/**
 * メッセージ画像URLプレビュー
 * @type {Ref<string>}
 */
const messageImageUrlPreview = ref("");

/**
 * メッセージリンクURL
 * @type {Ref<string>}
 */
const messageLinkUrl = ref("");

/**
 * メッセージ画像アクションタイプ
 * @type {Ref<string>}
 */
const messageImageActionType = ref("");

/**
 * URIタイプ
 * @type {Ref<string>}
 */
const uriType = ref("uri");

/**
 * メッセージテンプレートタイプ
 * @type {Ref<string>}
 */
const messageTemplateType = ref("");

/**
 * 配信グループ画像ID
 * @type {Ref<string>}
 */
const distributionGroupImageId = ref("");

/**
 * クリニックID
 * @type {Ref<number>}
 */
const clinicId = ref(0);

/**
 * 画像ファイル
 * @type {Ref<any>}
 */
const imageFiles = ref();

/**
 * ファイルリスト
 * @type {Ref<any[]>}
 */
const files = ref<any[]>([]);

/**
 * メッセージテキスト内容
 * @type {Ref<string>}
 */
const messageTextContent = ref("");

/**
 * 絵文字表示フラグ
 * @type {Ref<boolean>}
 */
const emojiOnShow = ref(false);

/**
 * ダイアログ表示フラグ
 * @type {Ref<boolean>}
 */
const dialogVisible = ref<boolean>(false);

/**
 * ページ離脱許可フラグ
 * @type {Ref<boolean>}
 */
const hasPermissionRedirect = ref(false);

/**
 * ページ離脱警告表示フラグ
 * @type {Ref<boolean>}
 */
const warningRedirectPage = ref(false);

/**
 * 次のルート
 * @type {Ref<string | null>}
 */
const nextRoute = ref<string | null>(null);

/**
 * 配信グループメッセージID
 * @type {Ref<string>}
 */
const distributionGroupMessageId = ref("");

/**
 * 絵文字ピッカーラッパー
 * @type {Ref<any>}
 */
const emojiPickerWrapper = ref();

/**
 * フォームバリデーション処理
 * @returns {Promise<boolean>} バリデーション結果
 */
const validate = async () => {
  const formObject = reactive({
    messageLinkUrl: messageLinkUrl.value,
    messageTextContent: messageTextContent.value,
    messageType: props.deliverySetting.message_type,
    messageImage: imageFiles.value,
    messageImageActionType: messageImageActionType.value,
    imageActionPostBack: imageActionPostBack.value,
    imageActionLink: imageActionLink.value,
    uriType: uriType.value,
  });

  const initValidation = useAsyncValidator(formObject, rules);
  const { execute } = get(initValidation);
  const { pass: fPass, errorFields: fErrorFields } = await execute();
  messageSettingErrors.value = fErrorFields || {};
  return fPass;
};

/**
 * メッセージタイプオプション
 * @type {Ref<Array<{name: string, value: string}>>}
 */
const messageTypeOptions = ref([
  { name: "選択", value: "" },
  { name: "テキストタイプ", value: "postback" },
  { name: "リンクタイプ", value: "uri" },
  { name: "クーポンタイプ", value: "coupon" },
  { name: "予約", value: "booking_uri" },
]);

/**
 * URIタイプオプション
 * @type {Ref<Array<{name: string, value: string}>>}
 */
const uriTypeOptions = ref([
  { name: "通常のURL", value: "uri" },
  { name: "予約", value: "booking_uri" },
]);

/**
 * イベントエミッター
 */

const currentUser = ref<ILineAccount>({
  id: 0,
  line_user_id: "",
  clinic_id: 0,
  customer_id: 0,
  name: "",
  avatar_url: "",
  message: {
    id: 0,
    channel_id: "",
    line_user_id: "",
    content: "",
    message_type: "",
    sender_type: "",
    created_at: "",
  },
} as ILineAccount);

/**
 * メッセージ設定の更新処理
 * @param {boolean} isSaveDraft - 下書き保存かどうか
 * @returns {Promise<any>} 更新結果
 */
const updateSetting = async (isSaveDraft = false) => {
  messageSettingErrors.value = {};
  set(saveDraftVisible, false);
  const isValidParams = await validate();
  if (!isValidParams) {
    notityErrorMsg(toast, "入力内容に不備があります。各項目を確認してください");
    set(warningRedirectPage, false);
    set(warningReturnVisible, false);
    return;
  }

  return new Promise((resolve, reject) => {
    const formData = new FormData();
    const messages = buildBodyCreate();
    messages["messages"].forEach((obj, index) => {
      for (let key in obj) {
        formData.append(`message_setting[${index}][${key}]`, (obj as any)[key]);
      }
    });
    formData.append("message_id", messages["id"]);

    if (isSaveDraft) {
      formData.append("status", "draft");
    }

    const token = getCookie("access_token");
    axios
      .patch(
        `${ApiRouterConstants.API_DISTRIBUTION_GROUPS}/${props.distributionGroupId}/message_settings?clinic_id=${clinicId.value}`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
        }
      )
      .then(response => {
        if (isSaveDraft) {
          currentMessageSetting.value = response.data["group_messages"];
          emits("saveMessageSetting", 4, currentMessageSetting.value);
          if (get(warningRedirectPage)) {
            set(warningRedirectPage, false);
            set(hasPermissionRedirect, true);
            if (nextRoute.value) {
              router.push(nextRoute.value);
            }
          } else {
            if (get(warningReturnVisible)) {
              back();
            } else {
              set(warningReturnVisible, false);
              set(saveDraftVisible, true);
            }
          }

          set(isAlreadySaveDraft, true);
        } else {
          emits("saveMessageSetting", 5, response.data["group_messages"]);
        }
        set(warningReturnVisible, false);
        resolve(response);
      })
      .catch(error => {
        console.log("errors", error);
        reject(error);
      });
  });
};

/**
 * TOPページに戻る処理
 */
const returnTop = () => {
  set(hasPermissionRedirect, true);
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUP_ROUTER_NAME);
};

/**
 * 現在のページに戻る処理
 */
const returnCurrentPage = () => {
  warningReturnVisible.value = false;
  saveDraftVisible.value = false;
};

/**
 * 下書き保存処理
 */
const saveDraft = async () => {
  await handleError(updateSetting(true));
};

onBeforeRouteLeave((to, _from, next) => {
  if (props.finalSetting) {
    next();
    return;
  }

  if (get(hasPermissionRedirect)) {
    next();
  } else {
    set(warningRedirectPage, true);
    set(nextRoute, to.fullPath);
    next(false);
  }
});

/**
 * 戻るボタンの処理
 */
const handleBackButton = () => {
  if (isAlreadySaveDraft.value) {
    warningReturnVisible.value = false;
    emits("resourcesFn", 3);
  } else {
    warningReturnVisible.value = true;
  }
};

/**
 * 変更を破棄する処理
 */
const disCardChanged = () => {
  emits("saveMessageSetting", 3, props.messageSetting);
};

/**
 * リダイレクト時の破棄処理
 */
const destroyWhenRedirect = async () => {
  try {
    if (!props.isEdit) {
      await DistributionGroupService.destroy(props.distributionGroupId);
    }
    set(hasPermissionRedirect, true);
    if (nextRoute.value) {
      router.push(nextRoute.value);
    }
  } catch (error) {
    console.log("error", error);
  }
};

/**
 * ページ離脱前の処理
 * @param {BeforeUnloadEvent} event - ページ離脱イベント
 */
const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = "";
  window.addEventListener("unload", async function () {
    if (!props.isEdit) {
      const url = `${ApiRouterConstants.API_DISTRIBUTION_GROUPS}/${props.distributionGroupId}`;
      await fetch(url, { method: "DELETE", keepalive: true });
    }
  });
};

/**
 * 保存処理
 */
const save = async () => {
  if (isAlreadySaveDraft.value) {
    emits("saveMessageSetting", 5, currentMessageSetting.value);
    return;
  }

  const [errUpdate] = await handleError(updateSetting());
  if (errUpdate) {
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
  }
};

/**
 * エラーハンドリング処理
 * @param {Promise<any>} promise - 処理するPromise
 * @returns {Promise<[any, any]>} エラーとデータの配列
 */
const handleError = (promise: Promise<any>) => {
  return promise.then(data => [undefined, data]).catch(error => [error, undefined]);
};

/**
 * メッセージ作成用のボディを構築
 * @returns {Object} メッセージ設定オブジェクト
 */
const buildBodyCreate = () => {
  const messages = Object.values(messageSettings());
  const messageParams = messages.map(message => {
    return message();
  });

  const filterMessage = messageParams.filter(message => message != null);
  return { id: get(distributionGroupMessageId), messages: filterMessage.flat(2) };
};

/**
 * メッセージ設定属性の割り当て
 */
const assignMessageSettingAttribute = () => {
  if (!props.messageSetting) return;

  const filterMessageSetting = props.messageSetting[0];
  if (!filterMessageSetting) {
    return;
  }

  set(distributionGroupMessageId, filterMessageSetting.id);

  filterMessageSetting.messages.forEach((message: any) => {
    assignTextMessageAttribute(message);
    assignUriMessageAttribute(message);
    assignImageMessageAttribute(message);
  });
};

/**
 * テキストメッセージ属性の割り当て
 * @param {any} message - メッセージオブジェクト
 */
const assignTextMessageAttribute = (message: any) => {
  if (message["content_type"] != "text") return;

  set(messageTextContent, message.content_data);
};

/**
 * URIメッセージ属性の割り当て
 * @param {any} message - メッセージオブジェクト
 */
const assignUriMessageAttribute = (message: any) => {
  if (message["content_type"] != "uri") return;

  uriType.value = props.deliverySetting.message_type == 4 ? "uri" : message?.content_label;
  set(messageLinkUrl, message.content_data);
};

/**
 * 画像メッセージ属性の割り当て
 * @param {any} message - メッセージオブジェクト
 */
const assignImageMessageAttribute = (message: any) => {
  if (message["content_type"] != "image") return;

  set(messageImageUrlPreview, message.content_data);
  set(imageFiles, message.content_data);
  set(distributionGroupImageId, message.distribution_group_image_id);
  set(messageImageActionType, message.message_action_type);
  if (message.message_action_type === "postback") {
    set(imageActionPostBack, message.message_action_data);
  } else if (message.message_action_type === "uri") {
    set(imageActionLink, message.message_action_data);
  } else if (message.message_action_type === "coupon") {
    set(imageActionLink, message.message_action_data);
  }
};

/**
 * メッセージ設定の取得
 * @returns {Object} メッセージ設定オブジェクト
 */
function messageSettings() {
  return {
    firstMessage: buildFirstMessage,
    secondMessage: buildSecondMessage,
  };
}

/**
 * 最初のメッセージを構築
 * @returns {Array} メッセージ配列
 */
function buildFirstMessage() {
  const messageContent = Object.values(firstMessageContent());
  if (messageContent.length == 0) return;

  return messageContent;
}

/**
 * 最初のメッセージ内容を取得
 * @returns {Object} メッセージ内容オブジェクト
 */
const firstMessageContent = () => {
  let messageContent = {
    text: { content_type: "text", content_data: messageTextContent.value },
  };

  if ([2, 4].includes(props.deliverySetting.message_type)) {
    (messageContent as any)["link"] = {
      content_type: "uri",
      content_data: messageLinkUrl.value,
      content_label: uriType.value,
    };
  }

  return messageContent;
};

/**
 * 2番目のメッセージを構築
 * @returns {Array} メッセージ配列
 */
function buildSecondMessage() {
  const messageContent = Object.values(secondMessageContent());
  if (messageContent.length == 0) return;

  return Object.values(secondMessageContent());
}
/* Add or delete value for object to modify second message container */
/**
 * 2番目のメッセージ内容を取得
 * @returns {Object} メッセージ内容オブジェクト
 */
const secondMessageContent = () => {
  if ([1, 2].includes(props.deliverySetting.message_type)) return [];

  const response = {
    image: {
      distribution_group_image_id: distributionGroupImageId.value,
      content_type: "image",
      content_data: imageFiles.value,
      message_action_type: messageImageActionType.value,
      message_action_data: messageImageActionData(messageImageActionType.value),
    },
  };
  return response;
};

/**
 * メッセージ画像アクションデータの取得
 * @param {any} action_type - アクションタイプ
 * @returns {string} アクションデータ
 */
const messageImageActionData = (action_type: any) => {
  return {
    postback: imageActionPostBack.value,
    uri: imageActionLink.value,
    coupon: imageActionLink.value,
  }[String(action_type)];
};

/**
 * 絵文字選択時の処理
 * @param {any} emoji - 選択された絵文字
 */
const onSelectEmoji = (emoji: any) => {
  messageTextContent.value += emoji.i;
};
/**
 * 絵文字表示の切り替え
 */
const showEmoji = () => {
  emojiOnShow.value = !emojiOnShow.value;
};
/**
 * テンプレート追加処理
 */
const addTemplate = () => {
  set(messageTemplateType, "add");
  dialogVisible.value = true;
};
/**
 * テンプレートポップアップを閉じる処理
 */
const onCloseTemplatePopup = () => {
  set(messageTemplateType, "");
  dialogVisible.value = false;
};
/**
 * テンプレート挿入処理
 * @param {any} template - 挿入するテンプレート
 */
const onInsertTemplate = (template: any) => {
  dialogVisible.value = false;
  const content = template.content_string
    .replaceAll("{{CustomerName}}", get(currentUser).name)
    .replaceAll("{{ClinicName}}", store.getters["authClient/selectedClinic"].name);
  set(messageTextContent, content);
};
/**
 * メッセージプレビュー処理
 */
const previewMessage = () => {
  set(messageTemplateType, "preview");
  dialogVisible.value = true;
};
/**
 * 戻る処理
 */
const back = () => {
  emits("resourcesFn", 3);
  set(warningReturnVisible, false);
};
/**
 * ファイル入力のトリガー処理
 */
const triggerFileInput = () => {
  upLoadImagePopUp.value = false;
  document.getElementById("uploadImage")?.click();
};
/**
 * ファイル入力処理
 * @param {Event} event - ファイル入力イベント
 */
const handleFileInput = (event: Event) => {
  // Handle the file input
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = e => {
    const result = e.target?.result;
    if (typeof result === "string") {
      messageImageUrlPreview.value = result;
    }
    imageFiles.value = file;
  };
  reader.readAsDataURL(file);
};

/**
 * クリニック情報の読み込み
 */
const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};

/**
 * ドキュメントクリック処理
 * @param {Event} event - クリックイベント
 */
const handleDocumentClick = (event: Event) => {
  if (emojiOnShow.value && emojiPickerWrapper.value && !emojiPickerWrapper.value.contains(event.target)) {
    emojiOnShow.value = false;
  }
};

/**
 * コンポーネントアンマウント前の処理
 */
onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
});

/**
 * コンポーネントマウント時の処理
 */
onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
  document.getElementById("step-setting")?.scrollIntoView();
});

/**
 * コンポーネントマウント前の処理
 */
onBeforeMount(async () => {
  document.addEventListener("click", handleDocumentClick);
  await loadClinicInfo();
  assignMessageSettingAttribute();
});

return (_ctx: any,_cache: any) => {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-content-wrapper", { 'pointer-events-none': props.finalSetting }])
    }, [
      _createVNode(_component_Card, { class: "mb-5 border-round-lg mt-5" }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        content: _withCtx(() => [
          _hoisted_2,
          (messageSettingErrors.value?.messageTextContent)
            ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(messageSettingErrors.value?.messageTextContent[0]?.message), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "w-full flex justify-content-end",
                  ref_key: "emojiPickerWrapper",
                  ref: emojiPickerWrapper
                }, [
                  _createVNode(_unref(EmojiPicker), {
                    onSelect: onSelectEmoji,
                    class: _normalizeClass(["absolute emoji-picker", { hidden: !emojiOnShow.value }]),
                    "group-names": _unref(GROUP_NAMES_EMOJI),
                    native: true,
                    "static-texts": _unref(PLACEHOLDER_EMOJI)
                  }, null, 8, ["class", "group-names", "static-texts"]),
                  _createElementVNode("span", {
                    class: "icon-lms_face icon",
                    onClick: showEmoji
                  })
                ], 512),
                _createElementVNode("span", {
                  class: "pi pi-comment btn-la-chat-plus cursor-pointer",
                  onClick: addTemplate
                }),
                _createVNode(_component_Dialog, {
                  visible: dialogVisible.value,
                  "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
                  modal: "",
                  class: "preview-image-dialog",
                  style: _normalizeStyle(messageTemplateType.value === 'add' ? { width: '75vw' } : { width: '50vw' })
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, _toDisplayString(messageTemplateType.value == "add" ? "コンテンツを選択" : "プレビュー確認"), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(LiveMessageTemplate, {
                      onOnClose: onCloseTemplatePopup,
                      onOnInsert: onInsertTemplate,
                      previewType: messageTemplateType.value,
                      previewMessageContent: messageTextContent.value,
                      previewUrlContent: [2, 4].includes(props.deliverySetting.message_type) ? messageLinkUrl.value : undefined,
                      previewImageContent: 
                    [3, 4].includes(props.deliverySetting.message_type) ? messageImageUrlPreview.value : undefined
                  
                    }, null, 8, ["previewType", "previewMessageContent", "previewUrlContent", "previewImageContent"])
                  ]),
                  _: 1
                }, 8, ["visible", "style"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createVNode(_component_Textarea, {
                class: "w-full border-round-lg border-noround-top",
                rows: "5",
                placeholder: "メッセージを入力。メッセージを入力",
                modelValue: messageTextContent.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((messageTextContent).value = $event))
              }, null, 8, ["modelValue"]), [
                [_vShow, files.value.length <= 0]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(messageTextContent.value.length) + " / 500", 1)
          ]),
          ([2, 4].includes(props.deliverySetting.message_type))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                (messageSettingErrors.value?.messageLinkUrl)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(messageSettingErrors.value?.messageLinkUrl[0]?.message), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  (props.deliverySetting.message_type == 2)
                    ? (_openBlock(), _createBlock(_component_Dropdown, {
                        key: 0,
                        modelValue: uriType.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((uriType).value = $event)),
                        optionLabel: "name",
                        optionValue: "value",
                        class: "w-full input-custom border-round-lg",
                        options: uriTypeOptions.value
                      }, null, 8, ["modelValue", "options"]))
                    : _createCommentVNode("", true),
                  (uriType.value == 'uri')
                    ? (_openBlock(), _createBlock(_component_InputText, {
                        key: 1,
                        modelValue: messageLinkUrl.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((messageLinkUrl).value = $event)),
                        "aria-describedby": "time-unit-help",
                        size: "large",
                        name: "can_booking_before_call",
                        class: "w-full mt-2 border-round-lg"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          ([3, 4].includes(props.deliverySetting.message_type))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                (messageSettingErrors.value?.messageImage)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(messageSettingErrors.value?.messageImage[0]?.message), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ([3, 4].includes(props.deliverySetting.message_type))
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        (messageImageUrlPreview.value)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: messageImageUrlPreview.value,
                              type: "file",
                              class: "image-preview border-round-lg",
                              alt: "Image Preview"
                            }, null, 8, _hoisted_23))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_Button, {
                        label: "画像を選択",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (upLoadImagePopUp.value = true)),
                        class: "btn-outline btn-outline-orange"
                      }),
                      _createElementVNode("input", {
                        type: "file",
                        id: "uploadImage",
                        accept: ".jpg,.jpeg,.png",
                        ref: "fileInput",
                        onChange: handleFileInput,
                        style: {"display":"none"}
                      }, null, 544),
                      _hoisted_25,
                      (messageSettingErrors.value?.imageActionPostBack)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_26, _toDisplayString(messageSettingErrors.value?.imageActionPostBack[0]?.message), 1))
                        : _createCommentVNode("", true),
                      (messageSettingErrors.value?.imageActionLink)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(messageSettingErrors.value?.imageActionLink[0]?.message), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Dropdown, {
                        modelValue: messageImageActionType.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((messageImageActionType).value = $event)),
                        optionLabel: "name",
                        optionValue: "value",
                        class: "w-full input-custom border-round-lg",
                        options: messageTypeOptions.value
                      }, null, 8, ["modelValue", "options"]),
                      (messageImageActionType.value == 'postback')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createVNode(_component_Textarea, {
                              modelValue: imageActionPostBack.value,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((imageActionPostBack).value = $event)),
                              "aria-describedby": "description-help",
                              type: "text",
                              size: "large",
                              name: "note",
                              rows: "10",
                              cols: "30",
                              class: "textarea-note w-100 mt-5 border-round-lg",
                              placeholder: "顧客の情報を追加できます。メモの情報は相手には公開されません。"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_29, _toDisplayString(imageActionPostBack.value.length) + " / 100", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (messageImageActionType.value == 'uri')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createVNode(_component_InputText, {
                              modelValue: imageActionLink.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((imageActionLink).value = $event)),
                              "aria-describedby": "time-unit-help",
                              size: "large",
                              name: "can_booking_before_call",
                              class: "w-full mt-5 border-round-lg",
                              placeholder: "URLを入力"
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (messageImageActionType.value == 'coupon')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createVNode(_component_InputText, {
                              modelValue: imageActionLink.value,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((imageActionLink).value = $event)),
                              "aria-describedby": "time-unit-help",
                              size: "large",
                              name: "can_booking_before_call",
                              class: "w-full mt-5 border-round-lg",
                              placeholder: "URLを入力"
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (__props.finalSetting == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createVNode(_component_Button, {
              label: "プレビュー確認",
              class: "ml-2 btn-outline btn-outline-orange",
              onClick: previewMessage
            })
          ]))
        : _createCommentVNode("", true),
      (__props.finalSetting == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createVNode(_component_Button, {
              class: "col-2 black-btn ml-5",
              label: "前設定へ戻る",
              onClick: handleBackButton
            }),
            _createVNode(_component_Button, {
              class: "col-2 temp-save-btn ml-5",
              label: "下書き保存",
              onClick: saveDraft
            }),
            _createVNode(_component_Button, {
              class: "col-2 create-btn ml-5",
              label: "設定最終確認",
              onClick: save
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_Dialog, {
      visible: warningReturnVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((warningReturnVisible).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_34
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_Button, {
            class: "col-3 temp-save-btn ml-5",
            label: "下書き保存",
            onClick: saveDraft
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "戻る",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (warningReturnVisible.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 confirm-delete-btn ml-5",
            label: "破棄する",
            onClick: disCardChanged
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: saveDraftVisible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((saveDraftVisible).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_36
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "TOPに戻る",
            onClick: returnTop
          }),
          _createVNode(_component_Button, {
            class: "col-3 create-btn ml-5",
            label: "作成を続ける",
            onClick: returnCurrentPage
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: warningRedirectPage.value,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((warningRedirectPage).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_38
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_Button, {
            class: "col-3 temp-save-btn mr-5",
            label: "下書き保存",
            onClick: saveDraft
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn mr-5",
            label: "戻る",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (warningRedirectPage.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 confirm-delete-btn",
            label: "破棄する",
            onClick: destroyWhenRedirect
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: upLoadImagePopUp.value,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((upLoadImagePopUp).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_40
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "upload-image-dialog",
          onClick: triggerFileInput
        }, _hoisted_44)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})